import CurrencyFormat from "react-currency-format";
import { useCurrency } from "../../hooks/useCurrency";

/**
 * Displays a monetary value using the active currency symbol.
 *
 * Props:
 *   value         number  -> amount to display (defaults to 0).
 *   decimalScale  number  -> number of decimals; if omitted, react-currency-format
 *                            preserves the original decimals (legacy behavior).
 *   signed        boolean -> if true, renders "+symbol" / "-symbol" depending on sign of value.
 *   ...rest                -> forwarded to react-currency-format.
 */
export const Money = ({
  value = 0,
  decimalScale,
  signed = false,
  ...rest
}) => {
  const { symbol } = useCurrency();
  const numeric = Number(value) || 0;

  const prefix = signed
    ? `${numeric >= 0 ? "+" : "-"}${symbol}`
    : symbol;

  // When signed, react-currency-format would render its own "-" for negatives,
  // duplicating the sign we already put in the prefix. Pass the absolute value
  // so the displayed magnitude is correct and the prefix carries the sign.
  const displayValue = signed ? Math.abs(numeric) : numeric;

  return (
    <CurrencyFormat
      value={displayValue}
      displayType="text"
      thousandSeparator={true}
      decimalScale={decimalScale}
      prefix={prefix}
      {...rest}
    />
  );
};

export default Money;
